<div class="login-wrapper">
    <form [formGroup]="createUserForm">

        <mat-card>
            <mat-toolbar color="primary" class="top-toolbar">
                <mat-toolbar-row>

                    Create New User

                </mat-toolbar-row>
            </mat-toolbar>
            <mat-card-content style="padding-top: 20px;">

                <label>Username</label>
                <mat-form-field>
                    <input matInput formControlName="usr_NAME" autocomplete="username">
                </mat-form-field>

                <label>Mail</label>
                <mat-form-field>
                    <input matInput formControlName="usr_MAIL" autocomplete="email">
                </mat-form-field>

                <label>Password</label>
                <mat-form-field>
                    <div class="password-container">
                        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="usr_PASSWORD" autocomplete="new-password">
                        <button mat-icon-button type="button" (click)="hidePassword = !hidePassword">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </div>
                </mat-form-field>
            </mat-card-content>

            <mat-toolbar style="margin-top: 20px;" class="bottom-toolbar">
                <mat-toolbar-row>
                    <mat-icon>arrow_back</mat-icon><a href="/login">Go Back</a>
                    <span class="spacer"></span>

                    <button mat-fab extended color="primary" (click)="onCreateAccount()" *ngIf="!loggingIn" [disabled]="createUserForm.invalid">
                        Create User  
                    </button>
                    <mat-spinner *ngIf="loggingIn" [diameter]="50"></mat-spinner>
                </mat-toolbar-row>
            </mat-toolbar>
        </mat-card>



    </form>

</div>